import { useState } from 'react';
import { isFeatureEnabled } from '../../../helpers/features';
import IconText from '../../generic/Icon/IconText';
import { DISABLE_SBOM_ORIGINALS } from '../../../../shared/featureFlags/flagNames';
import styles from './DisplayProjectNav.module.less';
import { nuc } from '../../../utils';
import ModalUploadSBOM from './ModalUploadSBOM';
import { Icon, icons } from '../../generic';
import Locator from '../../../../shared/Locator';
import { FileType } from '../../../../shared/fileUpload';

type Props = {
  locator: string;
};

const SBOMAffordances = ({ locator }: Props) => {
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const isSBOMProject = Locator.parse(locator).fetcher === 'sbom';
  const shouldShow = !isFeatureEnabled(DISABLE_SBOM_ORIGINALS) && isSBOMProject;
  if (!shouldShow) {
    return null;
  }
  return (
    <div className={styles.sbomAffordances}>
      <p className={`animated fadeInDown fast ${styles.sbomControl}`}>
        <a
          className={styles.sbomDownload}
          href={`/api/revisions/${nuc(locator)}/original-sbom`}
          download
        >
          <IconText icon="fa-solid fa-download" text="Download Original" marginAmount="4px" />
        </a>
      </p>
      <p className={`animated fadeInDown fast ${styles.sbomControl}`}>
        <button
          type="button"
          className={styles.sbomUploadButton}
          onClick={() => {
            setShouldShowModal(true);
          }}
        >
          <Icon icon={icons.upload} />
          <span className="font-family-monospace">Upload New SBOM</span>
        </button>
      </p>
      <ModalUploadSBOM
        fileType={FileType.SBOM}
        onHide={() => setShouldShowModal(false)}
        shouldShow={shouldShowModal}
      />
    </div>
  );
};

export default SBOMAffordances;
